import { createFileRoute } from '@tanstack/react-router';
import Storyteller from 'src/pages/Organization/Event/Mods/Storyteller';

export const Route = createFileRoute(
  '/$organizationSlug/events/$eventId/mods/$modId/storyteller',
)({
  component: Storyteller,
});
